const enableFeed = document.getElementById('enable-feed')
const sendFeed = document.getElementById('send-feed')
const hangUp = document.getElementById('hang-up')
const roomInfo = document.getElementById('room-info')
const control = document.getElementById('control-buttons')
const joinRoom = document.getElementById('join-room')
const remoteMediaMain = document.getElementById('remote-media')
const localMediaLeft = document.getElementById('local-video-left')
const localMediaRight = document.getElementById('local-video-right')
const muteBtn = document.getElementById('mute')

export default {
    enableFeed,
    sendFeed,
    hangUp,
    roomInfo,
    control,
    joinRoom,
    localMediaLeft,
    localMediaRight,
    remoteMediaMain,
    muteBtn,
}